<div *ngIf="instrument" class="price-historical-implied-volatility">
  <div class="price-historical-implied-volatility-header">
    <div class="price-historical-implied-volatility-symbol">
      <b>{{instrument.symbol}}</b>
      <span>{{instrument.company}}</span>
    </div>
    <div class="price-historical-implied-volatility-search">
      <dx-autocomplete
        #autocomplete
        [dataSource]="instruments"
        [(value)]="stockName"
        class="search-field"
        placeholder="Start typing stock symbol"
        valueExpr="nameAndExchange"
        searchMode="StartsWith"
        [showClearButton]="true"
        (onItemClick)="onAutocompleteItemClick($event)"
        [elementAttr]="{ class: 'instrument-select', style: 'transform:none;' }"
      >
        <div
          *dxTemplate="let item of 'item'"
          class="instrument-select-item favourites-instrument-select-item"
        >
          <div class="instrument-select-item__name-container">
            <div class="name-and-exchange">{{ item.nameAndExchange }}</div>
            <div class="stock-type">
              {{ getStockType(item) }} - {{ item.region }}
            </div>
          </div>
          <div class="instrument-select-item__company-container">
            <div class="company" title="{{ item.company }}">
              {{ item.company }}
            </div>
          </div>
        </div>
      </dx-autocomplete>
    </div>
  </div>

  <div class="price-historical-implied-volatility-tabs">
    <div (click)="tab = 'price&volume'" [class]="tab === 'price&volume' ? 'price-historical-implied-volatility-tab-selected' : ''">Price & Volume Charts</div>
    <div (click)="tab = 'historical&implied'" [class]="tab === 'historical&implied' ? 'price-historical-implied-volatility-tab-selected' : ''">Historical & Implied Volatility Charts</div>
    <div (click)="tab = 'table'" [class]="tab === 'table' ? 'price-historical-implied-volatility-tab-selected' : ''">Tables</div>
  </div>

  <div class="price-historical-implied-volatility-content" [style]="tab === 'table' ? 'overflow-x: auto; padding-top: 0' : ''">
    <div *ngIf="isDataLoaded()" class="price-historical-implied-volatility-table" [style]="tab === 'table' ? 'display: block' : 'display: none'">
      <div class="price-historical-implied-volatility-row" style="background-color: #fff; color: #6f6f6f;">
        <div class="price-historical-implied-volatility-cell"></div>
        <div class="price-historical-implied-volatility-cell">Current</div>
        <div class="price-historical-implied-volatility-cell">1 WK Ago</div>
        <div class="price-historical-implied-volatility-cell">52 WK Hi/Date</div>
        <div class="price-historical-implied-volatility-cell">52 WK Lo/Date</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="color: #6f6f6f;">
        <div class="price-historical-implied-volatility-cell" style="width: 100%;">
          Historical Volatility
          <i class="price-historical-implied-volatility-info">
            <div>Historical Volatility refers to the actual volatility experienced by the underlying stock over a specific look-back period</div>
          </i>
        </div>
      </div>
      <div class="price-historical-implied-volatility-row" style="background-color: #fff;">
        <div class="price-historical-implied-volatility-cell">10 days</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotDay.hv10)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotWeek.hv10)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.maxValue1)}} - {{formatDate(stockVolaInfo.allCompBoundVola.maxValueDate1)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.minValue1)}} - {{formatDate(stockVolaInfo.allCompBoundVola.minValueDate1)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row">
        <div class="price-historical-implied-volatility-cell">20 days</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotDay.hv20)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotWeek.hv20)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.maxValue2)}} - {{formatDate(stockVolaInfo.allCompBoundVola.maxValueDate2)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.minValue2)}} - {{formatDate(stockVolaInfo.allCompBoundVola.minValueDate2)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="background-color: #fff;">
        <div class="price-historical-implied-volatility-cell">30 days</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotDay.hv30)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.volaSnapshotWeek.hv30)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.maxValue3)}} - {{formatDate(stockVolaInfo.allCompBoundVola.maxValueDate3)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(stockVolaInfo.allCompBoundVola.minValue3)}} - {{formatDate(stockVolaInfo.allCompBoundVola.minValueDate3)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="color: #6f6f6f;">
        <div class="price-historical-implied-volatility-cell" style="width: 100%;">
          Implied Volatility
          <i class="price-historical-implied-volatility-info">
            <div>Implied Volatility is the market's estimate of future volatility, derived from the option's last traded price.</div>
          </i>
        </div>
      </div>
      <div class="price-historical-implied-volatility-row" style="background-color: #fff;">
        <div class="price-historical-implied-volatility-cell">
          IV index call
          <i class="price-historical-implied-volatility-info">
            <div style="left: 0; right: auto;">The IV Index Call is a specially designed, vega-weighted average of implied volatility using only call options.</div>
          </i>
        </div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(latestIvIndex.ivCall)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(weekIvIndex.ivCall)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.maximumCallValue)}} - {{formatDate(yearBounds.maximumCallDate)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.minimumCallValue)}} - {{formatDate(yearBounds.minimumCallDate)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="">
        <div class="price-historical-implied-volatility-cell">
          IV index put
          <i class="price-historical-implied-volatility-info">
            <div style="left: 0; right: auto;">The IV Index Put is a specially designed, vega-weighted average of implied volatility using only put options.</div>
          </i>
        </div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(latestIvIndex.ivPut)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(weekIvIndex.ivPut)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.maximumPutValue)}} - {{formatDate(yearBounds.maximumPutDate)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.minimumPutValue)}} - {{formatDate(yearBounds.minimumPutDate)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="background-color: #fff;">
        <div class="price-historical-implied-volatility-cell">
          IV index mean
          <i class="price-historical-implied-volatility-info">
            <div style="left: 0; right: auto;">The IV Index Mean is the average value of the IV Index Call and the IV Index Put.</div>
          </i>
        </div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(latestIvIndex.ivMean)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(weekIvIndex.ivMean)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.maximumMeanValue)}} - {{formatDate(yearBounds.maximumMeanDate)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(yearBounds.minimumMeanValue)}} - {{formatDate(yearBounds.minimumMeanDate)}}</div>
      </div>
      <div class="price-historical-implied-volatility-row" style="color: #6f6f6f;">
        <div class="price-historical-implied-volatility-cell" style="width: 100%;">
          Historical 30-days correlation Against S & P 500 Index
          <i class="price-historical-implied-volatility-info">
            <div style="top: auto; bottom: 20px; width: 400px">This refers to the 30-day historical correlation with the S&P 500 Index. Correlation is a statistical measure of how closely changes in one data series match changes in another. A correlation's sensitivity can vary depending on the period used. Shorter periods tend to be more responsive to market conditions, while longer periods provide more stability. A 30-day historical period aims to balance responsiveness and stability.</div>
          </i>
        </div>
      </div>
      <div class="price-historical-implied-volatility-row" style="background-color: #fff;">
        <div class="price-historical-implied-volatility-cell">30 days</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(correlationToday.correlation)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(correlationWeekly.correlation)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(correlationBounds.maxCorrelation)}} - {{formatDate(correlationBounds.maxCorrelationDate)}}</div>
        <div class="price-historical-implied-volatility-cell">{{formatPercent(correlationBounds.minCorrelation)}} - {{formatDate(correlationBounds.minCorrelationDate)}}</div>
      </div>
    </div>

    <div *ngIf="volatilityScale" class="price-historical-implied-volatility-chart" [style]="tab === 'price&volume' ? 'display: block' : 'display: none'">
      <div>
        <div><span style="background-color: #4DAA83"></span> Price</div>
      </div>
      <canvas id="priceVolumeChart"></canvas>
    </div>

    <div *ngIf="ivxHv" class="price-historical-implied-volatility-chart" [style]="tab === 'historical&implied' ? 'display: block' : 'display: none'">
      <div>
        <div><span style="background-color: #F89770"></span> HV 20</div>
        <div><span style="background-color: #4DAA83"></span> IV 30</div>
      </div>

      <canvas id="historicalImpliedChart"></canvas>
    </div>

    <div *ngIf="!isDataLoaded()" class="price-historical-implied-volatility-loading">
      <h2>Loading</h2>
    </div>
  </div>
</div>
